/* eslint-disable
    new-cap
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';

import SecondaryStructureTabTemplate from 'analyses/SecondaryStructureTabTemplate';

class OptionsView extends Backbone.View {}

class TabView extends Backbone.View {
  static initClass() {
    this.prototype.className = 'all-secondary-structures buffer-tab';
    this.prototype.events = {'click tbody > tr': 'openStructure'};
  }

  openStructure(e) {
    const index = $(e.currentTarget).data('index');
    return this.structures[index].showModal();
  }

  render() {
    const mainStructure = this.model.get('mainStructure');
    this.structures = this.model
      .get('structures')
      .filter((model) => model.get('dg') > mainStructure.get('dg')); // in case ViennaRNA decides to be dumb
    this.structures.unshift(mainStructure);
    // eslint-disable-next-line no-restricted-syntax
    _.each(this.structures, (model, index) =>
      model.set({
        smallSvg: $('<div>').html(model.getSvg(100, false))[0].innerHTML,
        index,
      })
    );

    this.$el.html(
      SecondaryStructureTabTemplate({
        models: this.structures,
        name: this.model.get('name').toLowerCase(),
        primer: this.model.get('primer'),
        primer2: this.model.get('primer2'),
        temperature: this.model.get('temperature'),
      })
    );
    return this;
  }
}
TabView.initClass();

export {TabView, OptionsView};
